import type { FuelTab } from './types.js';

/**
 * Yakıt yönetiminin yedi sekmesi (ortağın tasarımı 01–07; ADR 0117 §14) ve geldiği plan aşaması
 * (`docs/superpowers/plans/2026-10-23-yakit-mrv.md`). `null`: hazır. Hazır olmayan sekme sayfa
 * içinde "hazırlanıyor" panelini açar.
 */
export const FUEL_TABS: readonly { tab: FuelTab; path: string; stage: string | null }[] = [
  { tab: 'overview', path: '/fuel/overview', stage: null },
  { tab: 'tanks', path: '/fuel/tanks', stage: null },
  { tab: 'bunkering', path: '/fuel/bunkering', stage: null },
  { tab: 'transfers', path: '/fuel/transfers', stage: null },
  { tab: 'consumption', path: '/fuel/consumption', stage: null },
  { tab: 'rob', path: '/fuel/rob-reconciliation', stage: null },
  { tab: 'voyage-analysis', path: '/fuel/voyage-analysis', stage: null },
];

/** Tanklar sekmesinin alt yolu: Yakıt Türleri. */
export const FUEL_TYPES_PATH = '/fuel/tanks/fuel-types';

/** Yolun sekmesi: `/fuel` ilk hazır sekmedir. */
export function fuelTabOf(path: string): FuelTab {
  const match = FUEL_TABS.find((entry) => path === entry.path || path.startsWith(`${entry.path}/`));
  return match?.tab ?? FUEL_TABS.find((entry) => entry.stage === null)?.tab ?? 'tanks';
}
